import React from "react";

// Layout mínimo para el modo de acceso rápido (Bryan/Yazmin auditando desde
// el celular) — sin sidebar, solo un encabezado y el botón de salir.
export default function LayoutFoco({ titulo, onSalir, children }) {
  return (
    <div style={s.root}>
      <div style={s.topbar}>
        <h2 style={s.titulo}>{titulo}</h2>
        <button style={s.salirBtn} onClick={onSalir}>← Salir</button>
      </div>
      <div style={s.content}>{children}</div>
    </div>
  );
}

const s = {
  root: { minHeight: "100vh", background: "#eef4fc" },
  topbar: { background: "#2E4053", padding: "14px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 },
  titulo: { color: "#fff", fontSize: "16px", margin: 0, fontFamily: "sans-serif", fontWeight: "600" },
  salirBtn: { background: "rgba(255,255,255,0.12)", border: "1px solid rgba(255,255,255,0.3)", color: "#fff", borderRadius: "8px", padding: "8px 14px", fontSize: "13px", cursor: "pointer", fontFamily: "sans-serif" },
  content: { padding: "16px", maxWidth: "720px", margin: "0 auto" }
};
